<script setup lang="ts">
import { useVModel } from '@vueuse/core';

import { Sort } from '@/lib/customizers/common';
import { gtag } from '@/utils/analytics';

const props = defineProps<{ modelValue?: Sort }>();
const emit = defineEmits(['update:modelValue']);

const sortByValue = useVModel(props, 'modelValue', emit);

const handleSort = (sort: Sort) => {
  sortByValue.value = sort;
  gtag('event', 'customizer_sort', {
    sort_by: sort,
  });
};
</script>

<template>
  <div class="flex items-center ml-2 text-right lg:ml-0" data-test="catalog-sort">
    <span class="pr-2 text-sm font-proxima-nova">Sort By</span>
    <div
      class="text-sm cursor-pointer font-proxima-nova hover:underline"
      :class="{ 'font-semibold': sortByValue === Sort.Popularity }"
      @click="handleSort(Sort.Popularity)"
      @keydown.enter="handleSort(Sort.Popularity)"
      data-test="sort-type-popularity"
      tabindex="0"
    >
      Popularity
    </div>
    <span class="px-1 text-base text-neutral-400"> | </span>
    <div
      class="text-sm cursor-pointer font-proxima-nova hover:underline"
      :class="{ 'font-semibold': sortByValue === Sort.Price }"
      @click="handleSort(Sort.Price)"
      @keydown.enter="handleSort(Sort.Price)"
      data-test="sort-type-price"
      tabindex="0"
    >
      Price low to high
    </div>
  </div>
</template>
